<template>
  <div class="footer-container">
    <footer id="footer">
      <div id="copyright">
        | &copy; 2022 All rights reserved. | Josue Omar Tejada | Dev |
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>

<style>
.footer-container {
  height: 5vh;
  position: sticky;
  bottom: 0;
  border-top: 1px solid white;
  color: white;
  background-size: cover;
  background-attachment: fixed;
  background-image: url("../../images/abstract-2.jpg");
  display: flex;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width: 500px) {
  .footer-container {
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
}
</style>
